import React from 'react'
import styles from './Progress.module.css'

const ProgressBar = ({
    title,
    progress,
    maxProgress,
    bestProgress,
    color,
}) => {
    return (
        <div className={styles.progressBarContainer}>
            <p className={styles.progressBarTitle}>{title}</p>
            <div
                className={styles.progressBar}
                style={{
                    height: bestProgress ? (progress / bestProgress) * 100 + '%' : '100%',
                    backgroundColor: color
                }} />
            <p className={styles.progressBarProgress}>
                {progress + ' (' + Math.round((progress / maxProgress) * 100) + '%)'}</p>
        </div>
    )
}

const Progress = ({ words }) => {
    let totalWords = 0
    if (words) totalWords = Object.keys(words).length

    return (
        <div className={styles.container}>
            <div className={styles.wordsProgressContainer}>
                <p className={styles.wordsProgressTitle}>
                    {'Total words: ' + totalWords}
                </p>
                <div
                    className={styles.progressBarsContainer}>
                    <ProgressBar
                        title={'Weak'}
                        progress={13}
                        bestProgress={70}
                        maxProgress={123} 
                        color={'#FF6464'}/>
                    <ProgressBar
                        title={'Good'}
                        progress={70}
                        bestProgress={70}
                        maxProgress={123} 
                        color={'#309CFF'}/>
                    <ProgressBar
                        title={'Excellent'}
                        progress={40}
                        bestProgress={70}
                        maxProgress={123} 
                        color={'#26C281'}/>
                </div>
            </div>
        </div>
    )
}

export default Progress
